import React, {FC} from 'react';
import {Input} from 'antd';

interface INameInputProps {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  maxLength?: number;
  [key: string]: any;
}

export const NameInput: FC<INameInputProps> = ({
  onKeyDown,
  onChange,
  maxLength = 50, // По умолчанию 50 символов
  ...props
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Разрешаем только буквы, пробелы, дефисы и апострофы
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End', 'PageUp', 'PageDown'
    ];
    
    // Если это служебная клавиша, разрешаем
    if (allowedKeys.includes(e.key)) {
      if (onKeyDown) onKeyDown(e);
      return;
    }
    
    // Если это буква (включая кириллицу и латиницу), разрешаем
    if (/^[a-zA-Zа-яА-ЯёЁ\s\-']$/.test(e.key)) {
      // Проверяем длину
      const currentValue = (e.target as HTMLInputElement).value || '';
      if (currentValue.length >= maxLength) {
        e.preventDefault();
        return;
      }
      
      if (onKeyDown) onKeyDown(e);
      return;
    }
    
    // Все остальные символы блокируем
    e.preventDefault();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    
    // Удаляем все символы кроме букв, пробелов, дефисов и апострофов
    value = value.replace(/[^a-zA-Zа-яА-ЯёЁ\s\-']/g, '');
    
    // Ограничиваем длину
    if (value.length > maxLength) {
      value = value.substring(0, maxLength);
    }
    
    // Создаем новое событие с очищенным значением
    const newEvent = {
      ...e,
      target: {
        ...e.target,
        value: value
      }
    };
    
    // Вызываем оригинальный обработчик с очищенным значением
    if (onChange) {
      onChange(newEvent);
    }
  };

  return (
    <Input
      {...props}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      maxLength={maxLength}
    />
  );
};
